// @ts-expect-error ---> Default module, how to type it?
const DefaultModule = ({ moduleProps }) => <div className='mb-14 d-flex'>This module doesn&apos;t exist yet (<b>{moduleProps.__component}</b>)</div>

export default DefaultModule
